module.exports = __webpack_public_path__ + "img/slider_1.bc001577.jpg";